const API_SUBDOMAIN = (process.env.NODE_ENV == 'production' ? 'api' : 'dev-api')
const API_HOST = 'https://' + API_SUBDOMAIN + '.airzai.com/api/v1/'
//const API_HOST = 'http://localhost:3000/api/v1/'
const axios = require('axios')
const cookieHelper = require("./cookieHelper").default

export default {

    login: async function (email, password) {
        var url = API_HOST + 'admin/login'
        var body = { 'email': email, 'password': password }
        return await axios.post(url, body)
    },

    logout: async function () {
        var url = API_HOST + 'admin/logout'
        var body = { 'allDevices': false }
        return await axios.post(url, body, { headers: getHeader() })
    },

    findUserByEmail: async function (email) {
        var url = API_HOST + 'admin/users/search'
        var body = { 'email': email }
        return await axios.post(url, body, { headers: getHeader() })
    },

    getHomesForUser: async function (userId) {
        var url = API_HOST + 'admin/users/' + userId + '/homes'
        return await axios.get(url, { headers: getHeader() })
    },

    getDevicesForUser: async function (userId) {
        var url = API_HOST + 'admin/users/' + userId + '/devices'
        return await axios.get(url, { headers: getHeader() })
    },

    getUser: async function (userId) {
        var url = API_HOST + 'admin/users/' + userId
        return await axios.get(url, { headers: getHeader() })
    },

    updateUser: async function (userId, body) {
        var url = API_HOST + 'admin/users/' + userId
        return await axios.put(url, body, { headers: getHeader() })
    },

    getDevice: async function (deviceId) {
        var url = API_HOST + 'admin/devices/' + deviceId
        return await axios.get(url, { headers: getHeader() })
    },

    getUsersForHome: async function (homeId) {
        var url = API_HOST + 'admin/homes/' + homeId + '/users'
        return await axios.get(url, { headers: getHeader() })
    },

    getDevicesForHome: async function (homeId) {
        var url = API_HOST + 'admin/homes/' + homeId + '/devices'
        return await axios.get(url, { headers: getHeader() })
    },

    getDeviceState: async function (deviceId) {
        var url = API_HOST + 'admin/devices/' + deviceId + '/state'
        var result = await axios.get(url, { headers: getHeader() })



        return result
    },

    getFormulations: async function () {
        var url = API_HOST + 'formulations'
        return await axios.get(url, { headers: getHeader() })
    },

    getSolutions: async function () {
        var url = API_HOST + 'solutions'
        return await axios.get(url, { headers: getHeader() })
    },

    getFormulation: async function (formulationId) {
        var url = API_HOST + 'formulations/' + formulationId
        return await axios.get(url, { headers: getHeader() })
    },

    updateFormulation: async function (formulationId, body) {
        var url = API_HOST + 'formulations/' + formulationId
        return await axios.put(url, body, { headers: getHeader() })
    },

    createFormulation: async function (body) {
        var url = API_HOST + 'formulations'
        return await axios.post(url, body, { headers: getHeader() })
    },

    deleteFormulation: async function (formulationId) {
        var url = API_HOST + 'formulations/' + formulationId
        return await axios.delete(url, { headers: getHeader() })
    },

    sendDeviceCommand: async function (deviceId, body) {
        var url = API_HOST + 'admin/devices/' + deviceId + '/command'
        return await axios.post(url, body, { headers: getHeader() })
    }
}

function getHeader() {
    return { Authorization: 'Bearer ' + cookieHelper.getCookie("token"), 'Content-Type': 'application/json' }
}
